import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/api";
import { toast } from "sonner";

function googleLogin() {
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const redirect = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirect)}`;
}

export default function Login() {
  const { login, user, loading } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [signing, setSigning] = useState(false);
  const nav = useNavigate();

  // Already signed in? Skip the form.
  if (!loading && user) {
    const needsOnboarding = user.goal == null || user.daysPerWeek == null || user.age == null;
    return <Navigate to={needsOnboarding ? "/onboarding" : "/dashboard"} replace />;
  }

  const submit = async (e) => {
    e.preventDefault();
    setSigning(true); setErr("");
    try {
      const u = await login(email, password);
      toast.success("Welcome back.");
      if (u.goal == null || u.daysPerWeek == null || u.age == null) nav("/onboarding");
      else nav("/dashboard");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setSigning(false); }
  };

  return (
    <div className="min-h-screen bg-app max-w-md mx-auto px-6 pt-16">
      <div className="overline">Sign in</div>
      <h1 className="font-display text-4xl uppercase mt-3">Welcome back.</h1>
      <form className="mt-8 space-y-4" onSubmit={submit}>
        <input className="input" placeholder="Email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" />
        <input className="input" placeholder="Password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
        {err && <div className="text-red text-sm" data-testid="login-error">{err}</div>}
        <button className="btn btn-primary w-full" disabled={signing} data-testid="login-submit">{signing ? "…" : "Sign in"}</button>
      </form>
      <div className="flex items-center gap-3 my-6 text-xs text-t3">
        <span className="flex-1 border-hair-t" /> OR <span className="flex-1 border-hair-t" />
      </div>
      <button onClick={googleLogin} className="btn btn-outline w-full" data-testid="login-google">Continue with Google</button>
      <div className="mt-8 text-center text-sm text-t2">No account? <Link to="/register" className="text-lime">Create one</Link></div>
      <div className="mt-2 text-center text-sm"><Link to="/forgot-password" className="text-t3 hover:text-t2" data-testid="login-forgot">Forgot password?</Link></div>
    </div>
  );
}
